import { render, staticRenderFns } from "./BannerDualAction.vue?vue&type=template&id=00ad5560&scoped=true&"
import script from "./BannerDualAction.vue?vue&type=script&lang=js&"
export * from "./BannerDualAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad5560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ad5560')) {
      api.createRecord('00ad5560', component.options)
    } else {
      api.reload('00ad5560', component.options)
    }
    module.hot.accept("./BannerDualAction.vue?vue&type=template&id=00ad5560&scoped=true&", function () {
      api.rerender('00ad5560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/BannerDualAction.vue"
export default component.exports